import React from 'react';

const Close = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
    <title>close-5</title>
    <path fill="#929292" d="M29.768 1.352l-13.768 13.092-13.768-13.092-2.232 2.122 13.768 13.094-13.768 13.092 2.232 2.124 13.768-13.094 13.768 13.094 2.232-2.124-13.768-13.092 13.768-13.094z" />
  </svg>
);

export default Close;
